import { CustomFieldIdSchema } from './id'
import { z } from 'zod'

export const CUSTOM_FIELD_CALCULATION_OPERATIONS = ['addition', 'subtraction', 'multiplication', 'division'] as const
export type CalculationOperation = (typeof CUSTOM_FIELD_CALCULATION_OPERATIONS)[number]

const CalculatableFieldSchema = z.union([CustomFieldIdSchema, z.number()])
export type CalculatableField = z.infer<typeof CalculatableFieldSchema>

const MultiplicationOperationSchema = z.object({
  operation: z.literal('multiplication'),
  params: z.array(CalculatableFieldSchema),
})
export type MultiplicationOperation = z.infer<typeof MultiplicationOperationSchema>

const AdditionOperationSchema = z.object({
  operation: z.literal('addition'),
  params: z.array(CalculatableFieldSchema),
})
export type AdditionOperation = z.infer<typeof AdditionOperationSchema>

const DivisionOperationSchema = z.object({
  operation: z.literal('division'),
  dividend: CalculatableFieldSchema,
  divisor: CalculatableFieldSchema,
})
export type DivisionOperation = z.infer<typeof DivisionOperationSchema>

const SubtractionOperationSchema = z.object({
  operation: z.literal('subtraction'),
  minuend: CalculatableFieldSchema,
  subtrahend: CalculatableFieldSchema,
})
export type SubtractionOperation = z.infer<typeof SubtractionOperationSchema>

export const CustomFieldCalculationSchema = z.discriminatedUnion('operation', [
  MultiplicationOperationSchema,
  AdditionOperationSchema,
  DivisionOperationSchema,
  SubtractionOperationSchema,
])
export type CustomFieldCalculation = z.infer<typeof CustomFieldCalculationSchema>
